.queued_chat_interactive_area {
    display: flex;
    align-items: stretch;
    cursor: pointer;
    border-bottom: 1px solid color-mix(in srgb, var(--mantine-color-dark-9), transparent 60%);
    width: 100%;
    height: 60px;
    box-sizing: border-box; /* Make sure padding is included in height calculation */
    position: relative;
    padding: 12px;
    gap: var(--mantine-spacing-xxs);

    &:hover {
        background-color: color-mix(in srgb, var(--mantine-color-dark-4), transparent 30%);
    }
    &:where([data-selected="true"]) {
        /* Faded purple background for selected chats */
        background-color: color-mix(in srgb, var(--mantine-color-asurion-5), transparent 90%);
        &:hover {
            background-color: color-mix(in srgb, var(--mantine-color-asurion-5), transparent 75%);
        }
    }
    &:where([data-pending="true"]) {
        cursor: not-allowed;
    }
    &:focus-visible {
        outline: 2px solid var(--mantine-color-asurion-5);
        outline-offset: -2px;
        background-color: color-mix(in srgb, var(--mantine-color-dark-4), transparent 30%);
    }
}

.selected_chat_box {
    --select-width: 4px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;

    &:where([data-selected="true"]) {
        width: var(--select-width);
        background-color: var(--mantine-color-asurion-5);
        border-radius: var(--mantine-radius-md);
    }

    &:not([data-selected="true"]) {
        margin-left: var(--select-width);
    }
}

.chat_preview_badge {
    --badge-radius: var(--mantine-spacing-4xs);
    font-size: var(--mantine-font-size-xs);
    font-weight: var(--mantine-font-weight-normal);
    padding: var(--mantine-spacing-4xs) var(--mantine-spacing-3xs);
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.info_badge {
    background-color: var(--mantine-color-success-3);
    color: var(--mantine-color-dark-9);
    --badge-radius: var(--mantine-radius-sm);
    font-size: var(--mantine-font-size-xs);
    font-weight: var(--mantine-font-weight-normal);
    padding: 0 var(--mantine-spacing-3xs);
    text-transform: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.queued_chat_indicator {
    font-size: var(--mantine-font-size-sm);
    font-weight: var(--mantine-font-weight-heavy);
    padding: var(--mantine-spacing-4xs) var(--mantine-spacing-3xs);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute; /* absolute so it doesn't push other elements */
    z-index: 2; /* Ensure it appears above the avatar */
    top: 8px;
    right: 8px;
    border-radius: 50%; /* Ensure perfectly round badge */
    width: 16px;
    height: 16px;
    background-color: var(--mantine-color-asurion-5);
    border: none;
}

 .queued_chat_indicator_root {
    margin: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: auto;
}

.chat_preview_builder {
    width: 100%;
    max-width: calc(6.25rem * var(--mantine-scale));
    gap: var(--mantine-spacing-3xs);
    padding: 0;
}

.incoming_chat_copy {
    max-width: calc(6.25rem * var(--mantine-scale));
    gap: var(--mantine-spacing-3xs);
}

@media (min-width: $mantine-breakpoint-md) and (max-width: $mantine-breakpoint-lg) {
    .chat_preview_builder {
        max-width: calc(6.25rem * var(--mantine-scale));
    }
}

@media (min-width: $mantine-breakpoint-sm) {
    .chat_preview_builder {
        max-width: 5.25rem;
        font-size: 0.8em;
        line-height: 1.1;
        overflow: hidden;
    }
    .incoming_chat_copy {
        max-width: 5.25rem;
    }
}

@media (min-width: $mantine-breakpoint-lg) {
    .chat_preview_builder {
        max-width: 6.5rem;
    }
    .incoming_chat_copy {
        max-width: 6.5rem;
    }
}

@media (min-width: $mantine-breakpoint-xl) {
    .chat_preview_builder {
        max-width: 8.75rem;
    }
    .incoming_chat_copy {
        max-width: 8.75rem;
    }
}
